import nav from "./modules/nav.js";
import destinationSearch from "./modules/destinationSearch.js";
import loginPage from "./modules/loginPage.js";

window.addEventListener("DOMContentLoaded", function () {
  nav();
  loginPage();
  new destinationSearch(".js-destination-search");
});
